import React, { Component } from 'react';
import { CSVLink } from 'react-csv';
import moment from 'moment';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { DatePicker, Result, Button } from 'antd';
import { db } from '../../../config/Fire';
import * as Constants from '../../../constants/nodes_database';
import LoadingPage from '../../../components/LoadingPage';
import ReservationsByDateTableAdmin from '../../../components/tables/ReservationsByDateTableAdmin';
import * as ReserveConstants from './../../../constants/reserve';
import './styles.css';

const { RangePicker } = DatePicker;

const headers = [ 
    { label: "Fecha", key: "date" },
    { label: "Total de personas por fecha", key: "peopleCount" },
    { label: "Cantidad de reservas", key: "reservationCount" },
    { label: "Cantidad de restaurantes", key: "restaurants" },
    { label: "Reservas aceptadas", key: "reservationsAcceptedCount" },
    { label: "Reservas rechazadas", key: "reservationsRejectedCount" },
    { label: "Reservas canceladas", key: "reservationsCancelledCount" },
    { label: "Total de reservas", key: "reservationsTotalCount" },
    { label: "Total de personas", key: "peopleTotalCount" },
    { label: "Cantidad de días con reservas", key: "daysWithReservationsTotalCount" }
];

class AnalyticalReservationsRangeAdmin extends Component {
    state = {
        isInfoLoaded: true,
        rangeDate: null,
        data: null,
        csvData: null,
        generalInformation: {
            reservationsTotalCount: 0,
            peopleTotalCount: 0,
            daysWithReservationsTotalCount: 0,
        }
    }

    onDateChange = (dates, strings) => {
        console.log(strings)
        if(strings[0] === undefined || strings[1] === undefined || strings[0] === "" || strings[1] === "") {
            this.setState({ rangeDate: null, isInfoLoaded: true, data: null, csvData: null, generalInformation: { reservationsTotalCount: 0, peopleTotalCount: 0, daysWithReservationsTotalCount: 0 } });    
        } else {
            this.setState({ rangeDate: strings, isInfoLoaded: false, data: null, csvData: null, generalInformation: { reservationsTotalCount: 0, peopleTotalCount: 0, daysWithReservationsTotalCount: 0 } });
        }
    };

    renderReservationsByRange = rangeDate => {
        var reservationsMap = {};
        var generalInformation = {
            reservationsTotalCount: 0,
            peopleTotalCount: 0,
            daysWithReservationsTotalCount: 0,
        };
        var startDate = moment(rangeDate[0], "DD/MM/YYYY").utcOffset('-0300').startOf('date').toDate().getTime();
        var endDate = moment(rangeDate[1], "DD/MM/YYYY").utcOffset('-0300').endOf('date').toDate().getTime();
        db.ref(`${Constants.RESERVATIONS}`).orderByChild("dateInteger").startAt(startDate).endAt(endDate).once("value")
        .then((reserveSnap) => {
            if(reserveSnap.exists()) {
                reserveSnap.forEach((reservationSnap) => {
                    var reservation = reservationSnap.val();
                    if(reservationsMap[reservation.date] !== undefined) {
                        reservationsMap[reservation.date]['reservationCount'] = reservationsMap[reservation.date]['reservationCount'] + 1;
                        reservationsMap[reservation.date]['peopleTotalCount'] = reservationsMap[reservation.date]['peopleTotalCount'] + reservation.peopleCount;
                        if(reservationsMap[reservation.date]['restaurants'].indexOf(reservation.restoId) === -1) {
                            reservationsMap[reservation.date]['restaurants'].push(reservation.restoId);
                        }
                        switch (reservation.state) {
                            case ReserveConstants.RESERVE_STATE.accepted:
                                reservationsMap[reservation.date]['reservationsAcceptedCount'] = reservationsMap[reservation.date]['reservationsAcceptedCount'] + 1;
                                break;
                            case ReserveConstants.RESERVE_STATE.rejected:
                                reservationsMap[reservation.date]['reservationsRejectedCount'] = reservationsMap[reservation.date]['reservationsRejectedCount'] + 1;
                                break;
                            case ReserveConstants.RESERVE_STATE.cancelled:
                                reservationsMap[reservation.date]['reservationsCancelledCount'] = reservationsMap[reservation.date]['reservationsCancelledCount'] + 1;
                                break;
                            default:
                                break;
                        }
                    } else {
                        reservationsMap[reservation.date] = {
                            'reservationCount': 1,
                            'peopleTotalCount': reservation.peopleCount,
                            'restaurants': [reservation.restoId]
                        }
                        switch (reservation.state) {
                            case ReserveConstants.RESERVE_STATE.accepted:
                                reservationsMap[reservation.date]['reservationsAcceptedCount'] = 1;
                                reservationsMap[reservation.date]['reservationsRejectedCount'] = 0;
                                reservationsMap[reservation.date]['reservationsCancelledCount'] = 0;
                                break;
                            case ReserveConstants.RESERVE_STATE.rejected:
                                reservationsMap[reservation.date]['reservationsAcceptedCount'] = 0;
                                reservationsMap[reservation.date]['reservationsRejectedCount'] = 1;
                                reservationsMap[reservation.date]['reservationsCancelledCount'] = 0;
                                break;
                            case ReserveConstants.RESERVE_STATE.cancelled:
                                reservationsMap[reservation.date]['reservationsAcceptedCount'] = 0;
                                reservationsMap[reservation.date]['reservationsRejectedCount'] = 0;
                                reservationsMap[reservation.date]['reservationsCancelledCount'] = 1;
                                break;
                            default:
                                reservationsMap[reservation.date]['reservationsAcceptedCount'] = 0;
                                reservationsMap[reservation.date]['reservationsRejectedCount'] = 0;
                                reservationsMap[reservation.date]['reservationsCancelledCount'] = 0;
                                break;
                        }
                    }
                    generalInformation.reservationsTotalCount ++;
                    generalInformation.peopleTotalCount += reservation.peopleCount;
                })
                var data = [];
                var csvData = [];
                var keysTodayReservationsMap = Object.keys(reservationsMap);
                generalInformation.daysWithReservationsTotalCount = keysTodayReservationsMap.length;
                keysTodayReservationsMap.forEach((keyResto, index) => {
                    data.push({ date: keyResto, ...reservationsMap[keyResto] });
                    if(index === 0) {
                        csvData.push({
                            date: keyResto,
                            reservationCount: reservationsMap[keyResto]['reservationCount'],
                            peopleCount: reservationsMap[keyResto]['peopleTotalCount'],
                            restaurants: reservationsMap[keyResto]['restaurants'].length,
                            reservationsAcceptedCount: reservationsMap[keyResto]['reservationsAcceptedCount'],
                            reservationsRejectedCount: reservationsMap[keyResto]['reservationsRejectedCount'],
                            reservationsCancelledCount: reservationsMap[keyResto]['reservationsCancelledCount'],
                            reservationsTotalCount: generalInformation.reservationsTotalCount,
                            peopleTotalCount: generalInformation.peopleTotalCount,
                            daysWithReservationsTotalCount: generalInformation.daysWithReservationsTotalCount
                        });
                    } else {
                        csvData.push({
                            date: keyResto,
                            reservationCount: reservationsMap[keyResto]['reservationCount'],
                            peopleCount: reservationsMap[keyResto]['peopleTotalCount'],
                            restaurants: reservationsMap[keyResto]['restaurants'].length,
                            reservationsAcceptedCount: reservationsMap[keyResto]['reservationsAcceptedCount'],
                            reservationsRejectedCount: reservationsMap[keyResto]['reservationsRejectedCount'],
                            reservationsCancelledCount: reservationsMap[keyResto]['reservationsCancelledCount'],
                        });
                    }
                });
                console.log(reservationsMap)
                this.setState({ isInfoLoaded: true, data, rangeDate, generalInformation, csvData });
            } else {
                this.setState({ isInfoLoaded: true, rangeDate, data: null, generalInformation, csvData: null });
            }
        })
        .catch((err) => {

        });
    }

    downloadCSVTable = () => {
        this.setState(() => {
            this.csvLink.link.click();
        })
    }

    render() {
        return (
            <div>
                {
                    this.state.isInfoLoaded ?
                        <div>
                            {
                                <Grid className="gridCont">
                                    <Row center="xs">
                                        <Col xs={4}>
                                            <h2>Total de reservas: {this.state.generalInformation.reservationsTotalCount}</h2>
                                        </Col>
                                        <Col xs={4}>
                                            <h2>Total de personas: {this.state.generalInformation.peopleTotalCount}</h2>
                                        </Col>
                                        <Col xs={4}>
                                            <h2>Cantidad de días con reservas: {this.state.generalInformation.daysWithReservationsTotalCount}</h2>
                                        </Col>
                                    </Row>
                                    {(this.state.csvData && this.state.csvData.length !== 0) &&
                                        <Row center="xs">
                                            <Col xs={12}>
                                                <Button onClick={this.downloadCSVTable} type="primary">Descargar tabla</Button>
                                                <CSVLink headers={headers} data={this.state.csvData} separator={";"} style={{ display: 'none' }} ref={(r) => this.csvLink = r} target="_blank" filename={`Reservando - Reporte de reservas (${this.state.rangeDate[0]} - ${this.state.rangeDate[1]}).csv`}>Descargar tabla</CSVLink>
                                            </Col>
                                        </Row>
                                    }
                                    <Row className="reservationsCont">
                                        <Col xs={12} sm={2} md={3}>
                                            <RangePicker className="rangePickerCont" format={'DD/MM/YYYY'} value={this.state.rangeDate && [moment(this.state.rangeDate[0], 'DD/MM/YYYY'), moment(this.state.rangeDate[1], 'DD/MM/YYYY')]} onChange={(dates, strings) => { this.onDateChange(dates, strings)}}/>
                                        </Col>
                                        <Col xs={12} sm={10} md={9}>
                                        {
                                            this.state.rangeDate !== null ?
                                                this.state.data ?
                                                    <div>
                                                        {
                                                            <ReservationsByDateTableAdmin data={this.state.data} />
                                                        }
                                                    </div>
                                                    :
                                                    <Result className="resultWarningCont"
                                                    status="warning"
                                                    title="No hay reservas para el rango de fechas indicado." />
                                                    :
                                                    <div className="selectRangeNoticeCont">
                                                        <h2>Seleccione un rango de fechas</h2>
                                                    </div>
                                        }
                                        </Col>
                                    </Row>
                                </Grid>
                            }
                        </div>
                        :
                        <div>
                            <LoadingPage />
                            {this.renderReservationsByRange(this.state.rangeDate)}
                        </div>
                }
            </div>
        );
    }
}

AnalyticalReservationsRangeAdmin.propTypes = {

};

export default AnalyticalReservationsRangeAdmin;